import React, { useState } from "react";
import "./Admin.css";
import AddProduct from "./AddProduct";
import ProductList from "./ProductList";


export default function Admin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = () => {
    if (username === "admin" && password === "admin123") {
      setIsAdmin(true);
      setError("");
    } else {
      setError("Invalid credentials");
    }
  };
  return (
    <div className="admin-container">
  {!isAdmin ? (
        <div className="login-box">
          <h2>Admin Login</h2>

          <input
            type="text"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button onClick={handleLogin}>Login</button>

          {error && <p className="error">{error}</p>}
        </div>
      ) : (
        <div className="showdiv">
          <div className="admin-header">
            <h1>Admin Dashboard</h1>
            <p>Manage your products easily</p>
          </div>

          <div className="admin-content">
            <div className="admin-card">
              <h2>Add Product</h2>
              <AddProduct />
            </div>

            <div className="admin-card">
              <h2>Product List</h2>
              <ProductList />
            </div>
          </div>
        </div>
      )}

    </div>
  );
}